import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var heading_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M6 5V18.5911L12 13.8473L18 18.5911V5H6Z" }) });
export {
  heading_default as default
};
//# sourceMappingURL=heading.js.map
